/*
 * @Description: 聚合推广页面
 * @Author: maowy
 * @Date: 2020-07-16 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-08-Th 10:26:01
*/

import Vue from 'vue'
import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Popup, Loading } from 'vant'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
// import ajax from '../../http/ajax'
import {
    getLocalConfig
} from '@/utils/storage.js'
import {
    wxShare,
} from '@/utils/wxsdk'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import InfiniteLoading from 'vue-infinite-loading'
import 'swiper/dist/css/swiper.css'

Vue.use(Popup)
Vue.use(Loading)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.mergeSpread,
    components: {
        QualityImg,
        swiper,
        swiperSlide,
        InfiniteLoading
    },
    data () {
        return {
            isShowMore: false,
            isShowGoTop: false,
            isShowExplain: false,
            topic_id: '',
            sstore_id: '',
            isPosition: false, // 是否获取当前位置
            ajaxClosesParam: {}, // 最近门店信息-请求参数
            jumpGoodsParam: {}, // 跳转商品详情请求参数
            swiperOption: {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 15,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'slide_dot_active',
                    bulletClass: 'slide_dot'
                },
                on: {
                    click: (v) => { // 当loop：true时，swiper从第一张直接划到最后一次，img里面添加的事件会不执行，故在此做处理
                        let item = {
                            source: v.target.getAttribute('data-source'),
                            spu_id: v.target.getAttribute('data-spu_id'),
                            type: v.target.getAttribute('data-type')
                        }
                        this.pptJump(item)
                    }
                }
            },
            showBanner: false, // 主推楼层显示隐藏
            isGoMore: false, // 是否点击楼层更多
            floor_id: '', // 楼层id
            page: 1,
            pagesize: 2,
            handle_floor_list: [],
            serchFixed: false, // 是否固定搜索
            position: { // 高德经纬度（腾讯）
                longitude: '',
                latitude: ''
            }
        }
    },
    computed: {
        ...mapState({
            list: ({ mergeSpread }) => mergeSpread.data_list,
            floor_list: ({ mergeSpread }) => mergeSpread.floor_list, // 楼层的数据,
            isWeixin: ({ appInfo }) => appInfo.isWeixin
        }),
    },
    watch: {
        '$route' (to, from) {
            // 对路由变化作出响应...
            if (to.path === from.path) {
                /* 滚动到页面顶部 */
                document.body.scrollIntoView()
                this.page = 1
                this.handle_floor_list = []
                this.getData()
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                // this.infinite()
            }
        },
        isPosition (newValue) {
            if (newValue) {
                this.getAddressData()
            }
        },
    },
    created () {
        this.initLocation()
        this.getData()
    },
    activated () {
        // this.getData()
    },
    async mounted () {

    },
    methods: {
        ...mapActions([
            'getMergeSpreadDetail',
            'getMergeSpreadFloorList',
            'getLocation',
            'saveAddressInfo',
            'getAddress',
        ]),
        getData () {
            const { topic_id } = this.$route.query
            this.topic_id = topic_id
            this.getBasicData()
        },
        infinite: _.throttle(function () {
            let params = {
                topic_id: this.topic_id,
                page: this.page,
                pagesize: this.pagesize
            }
            this.getMergeSpreadFloorList(params).then(() => {
                if (this.floor_list.floor_infos && this.floor_list.floor_infos.length && this.floor_list.floor_infos.length === this.pagesize) {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                } else {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                }
                this.handle_floor_list = this.handle_floor_list.concat(this.floor_list.floor_infos)
            }).catch(() => {
            })
        }, 500),
        /* 获取推广基本信息 */
        async getBasicData () {
            // 请求页面数据
            this.showLoading()
            this.getMergeSpreadDetail({ topic_id: this.topic_id }).then(() => {
                this.hideLoading()
                // 处理主推图片环路，大于2才设置true
                if (this.list.main_brand_advs && this.list.main_brand_advs.length) {
                    if (this.list.main_brand_advs.length > 2) {
                        this.swiperOption['loop'] = true
                    } else {
                        this.swiperOption['loop'] = false
                    }
                    this.showBanner = true
                } else {
                    this.showBanner = false
                }
                this.$emit('setHeader', {
                    title: this.list.title || '',
                    showHeader: true,
                    showLeft: false,
                    scrollTop: ''
                })
                document.title = this.list.title
                // 配置微信的数据
                this.configWxShare(this.list.share)
                // 当解释说明的高度大于90的时候出现更多字样
                this.$nextTick(() => {
                    if (!this.$refs.info) return
                    const info = this.$refs.info
                    const infoParent = this.$refs.infoParent

                    let height = null
                    let maxHeight = null
                    if (window.getComputedStyle) {
                        // 非IE浏览器获取方法
                        height = window.getComputedStyle(info).height
                        maxHeight = window.getComputedStyle(infoParent).height
                    } else {
                        // IE浏览器获取方法
                        height = info.currentStyle['height']
                        maxHeight = infoParent.currentStyle['height']
                    }
                    if (height) {
                        String(height).split('px')[0] * 1 <= String(maxHeight).split('px')[0] * 1 ? this.isShowMore = false : this.isShowMore = true
                    }
                })
            }).catch(() => {
                this.hideLoading()
            })
            // 监听页面滚动是否出现点击去顶部的按钮
            window.addEventListener('scroll', this.scrollToTop)
        },
        // 跳转聚合推广门店列表
        goStoreList () {
            this.$router.push({
                name: 'mergeSpreadStoreList',
                query: {
                    ...this.position,
                    topic_id: this.topic_id,
                    goods_id: this.jumpGoodsParam.goods_id,
                    spu_id: this.jumpGoodsParam.spu_id,
                    goods_type: this.jumpGoodsParam.goods_type,
                    spec_id: this.jumpGoodsParam.spec_id,
                    page_code: 'mergeSpread',
                }
            })
        },
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: detail.title || '',
                    imgUrl: detail.imgUrl || '',
                    desc: detail.desc || '',
                })
            }
        },
        // 查看更多解释说明
        explainMore () {
            this.isShowExplain = true
        },
        hasLocation () {
            if (this.position.longitude && this.position.latitude) {
                return true
            } else {
                return false
            }
        },
        initLocation () {
            const addressInfo = getLocalConfig('AddressInfo')
            if (addressInfo && !_.isEmpty(addressInfo)) {
                const position = _.pick(addressInfo, ['longitude', 'latitude'])
                Object.assign(this.position, position)
            }
        },
        getAddressData () {
            if (!this.longitude) {
                this.getAddress(Object.values(this.position))
                    .then(res => {
                        const param = {
                            longitude: this.position.longitude,
                            latitude: this.position.latitude,
                            province: res.addressComponents.province,
                            city: res.addressComponents.city,
                            district: res.addressComponents.district,
                            name: res.address || '',
                            formattedAddress: res.address
                        }
                        this.saveAddressInfo(param)
                        !this.isGoMore && this.getClosestData()
                        this.isGoMore && this.jumpMore()
                    })
            }
        },
        getMyLocation (isGoMore) {
            this.isGoMore = isGoMore
            if (this.hasLocation()) {
                !this.isGoMore && this.getClosestData()
                this.isGoMore && this.jumpMore()
            } else {
                this.showLoading()
                // type=1,不展示自定义gps提示弹窗
                const options = { timeout: 3000, from: 'noTips' }
                // this.getLocation(options).then(this.showPosition).catch(this.showErr)
                this.getLocation(options).then(this.showPosition).catch(this.showErr).finally(() => {
                    this.hideLoading()
                    this.isPosition = true
                    this.getAddressData()
                })
            }
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.position.longitude = position.lng
            this.position.latitude = position.lat
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.position.longitude = 113.332926
            this.position.latitude = 23.202723
        },
        // 广告跳转
        pptJump (item) { // 1商品详情 2 h5
            if (!item.source) return
            if (item.type == 1) { // eslint-disable-line
                this.getStoreDetail(item.spu_id, 'agent', item.source)
            } else {
                window.location.href = item.source
            }
        },
        getStoreDetail (spu_id, goods_type, spec_id = '') {
            this.jumpGoodsParam = {
                spu_id,
                goods_type,
                spec_id,
                page_code: 'mergeSpread',
            }
            this.getMyLocation(false)
        },
        // 获取最近门店信息
        getClosestData () {
            Object.assign(this.jumpGoodsParam, {
                topic_id: this.topic_id,
                page_code: 'mergeSpread'
            })
            this.$router.push({
                name: 'moreSstoreGoodsDetail',
                query: this.jumpGoodsParam
            })
        },
        // 去更多楼层事件
        goMoreFloor (floor_id) {
            this.floor_id = floor_id
            this.getMyLocation(true)
        },
        jumpMore () {
            this.$router.push({
                name: 'goodsList',
                query: {
                    ...this.position,
                    topic_id: this.topic_id,
                    isPosition: this.isPosition,
                    activity_id: this.list.activity_id,
                    floor_id: this.floor_id,
                    goMergeStoreList: 1, // 用于判断跳转聚合推广选择门店列表
                    page_code: 'mergeSpread',
                }
            })
        },
        // 点击之后页面滚到最上面
        toTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.isShowGoTop = true
            } else {
                that.isShowGoTop = false
            }
            if (that.scrollTop > 300) {
                that.serchFixed = true
            } else {
                that.serchFixed = false
            }
        }
    },

    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
}
